<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :players="players"
      :stats="stats"
      :today-stats="todayStats"
      :yesterday-stats="yesterdayStats"
      :aggregation="chart.aggregation"
      :gender="gender"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import TotalDistanceChart from '@/components/charts/implementation/TotalDistanceChart.vue'
import HighSpeedRunningChart from '@/components/charts/implementation/HighSpeedRunningChart.vue'
import VolumeIntensityChart from '@/components/charts/implementation/VolumeIntensityChart.vue'
import MaxVelocityChart from '@/components/charts/implementation/MaxVelocityChart.vue'
import AccelerationsDecelerationsChart from '@/components/charts/implementation/AccelerationsDecelerationsChart.vue'
import AccelerationsDecelerationsDistanceChart
  from '@/components/charts/implementation/AccelerationsDecelerationsDistanceChart.vue'
import SpeedZoneChart from '@/components/charts/implementation/SpeedZoneChart.vue'
import VolumeIntensityScatterChart from '@/components/charts/implementation/VolumeIntensityScatterChart.vue'
import MaxAvgHeartRateChart from '@/components/charts/implementation/MaxAvgHeartRateChart.vue'
import TrimpMinChart from '@/components/charts/implementation/TrimpMinChart.vue'
import HrZoneChart from '@/components/charts/implementation/HrZoneChart.vue'
import TeamIndicatorsChart from '@/components/charts/implementation/TeamIndicatorsChart.vue'
import EnjoymentDistributionChart from '@/components/charts/implementation/EnjoymentDistributionChart.vue'
import TrainingGradeDistributionChart from '@/components/charts/implementation/TrainingGradeDistributionChart.vue'
import PainChart from '@/components/charts/implementation/PainChart.vue'
import SdnnRmssdChart from '@/components/charts/implementation/SdnnRmssdChart.vue'
import Pnn50Nn50Chart from '@/components/charts/implementation/Pnn50Nn50Chart.vue'
import Sdann2Sdann5Chart from '@/components/charts/implementation/Sdann2Sdann5Chart.vue'
import SdnnIndexChart from '@/components/charts/implementation/SdnnIndexChart.vue'
import VolumeDistributionChart from '@/components/charts/implementation/VolumeDistributionChart.vue'
import IntensityDistributionChart from '@/components/charts/implementation/IntensityDistributionChart.vue'
import MinutesPlayedChart from '@/components/charts/implementation/MinutesPlayedChart.vue'
import MatchTimelineChart from '@/components/charts/implementation/MatchTimelineChart.vue'

export default {
  name: 'PerformanceGraph',
  components: {
    TotalDistanceChart,
    HighSpeedRunningChart,
    VolumeIntensityChart,
    MaxVelocityChart,
    AccelerationsDecelerationsChart,
    AccelerationsDecelerationsDistanceChart,
    SpeedZoneChart,
    VolumeIntensityScatterChart,
    VolumeDistributionChart,
    IntensityDistributionChart,
    MaxAvgHeartRateChart,
    TrimpMinChart,
    HrZoneChart,
    TeamIndicatorsChart,
    EnjoymentDistributionChart,
    TrainingGradeDistributionChart,
    PainChart,
    SdnnRmssdChart,
    Pnn50Nn50Chart,
    Sdann2Sdann5Chart,
    SdnnIndexChart,
    MinutesPlayedChart,
    MatchTimelineChart
  },
  props: {
    players: {
      type: Array,
      default: () => []
    },
    stats: {
      type: [Object, Array],
      default: () => ({})
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    todayStats: {
      type: Object,
      default: () => ({})
    },
    yesterdayStats: {
      type: Object,
      default: () => ({})
    },
    gender: {
      type: String,
      default: 'male'
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        TDIST_MMIN: 'TotalDistanceChart',
        HSR_EFF: 'HighSpeedRunningChart',
        VOL_INT: 'VolumeIntensityChart',
        MAXVEL_ALL: 'MaxVelocityChart',
        ACC_DEC: 'AccelerationsDecelerationsChart',
        ACC_DEC_DIST: 'AccelerationsDecelerationsDistanceChart',
        SPD_ZONE: 'SpeedZoneChart',
        VOL_INT_SCAT: 'VolumeIntensityScatterChart',
        VOL_DIST: 'VolumeDistributionChart',
        INTS_DIST: 'IntensityDistributionChart',
        MAXHR_AVGHR: 'MaxAvgHeartRateChart',
        TRIMP_MIN: 'TrimpMinChart',
        HR_ZONE: 'HrZoneChart',
        TL_RPE_TTM: 'TeamIndicatorsChart',
        ENJ_DIST: 'EnjoymentDistributionChart',
        RPE_DIST: 'TrainingGradeDistributionChart',
        PAIN: 'PainChart',
        SDNN_RMSSD: 'SdnnRmssdChart',
        PNN50_NN50: 'Pnn50Nn50Chart',
        SDNN2_SDNN5: 'Sdann2Sdann5Chart',
        SDANN2_SDANN5: 'SdnnIndexChart',
        MINUTES_PLAYED: 'MinutesPlayedChart',
        MATCH_TIMELINE: 'MatchTimelineChart'
      }

      return componentMap[this.chart.key] || null
    }
  }
}
</script>
